export enum ToggleButtonSize {
  Medium = 'medium',
  Large = 'large',
}

export enum ToggleBackgroundColor {
  Default = 'default',
  Red = 'red',
}
